'use client';

import { useTrackRoute } from '@/analytics/useTrackRoute';
type Props = {
  aggregate?: 'CustomerSession' | 'Customer' | 'ProductOffer';
};
export function TrackRouteHandler(props: Props) {
  useTrackRoute(props.aggregate);

  return null;
}
